module.exports = __webpack_public_path__ + "img/CAR-03.d47e57f3.svg";